import { createAsyncThunk } from "@reduxjs/toolkit";

import { fetchPhoneDirectoryList } from "../../apis/phoneDirectory";

export const fetchPhoneDirectoryListData = createAsyncThunk(
  "phoneDirectory/fetchPhoneDirectoryList",
  async (
    query: {
      search?: string;
      page?: number;
      limit?: number;
      sortBy?: string;
      sortOrder?: "asc" | "desc";
    },
    { rejectWithValue }
  ) => {
    try {
      const phoneList = await fetchPhoneDirectoryList(query);
      return phoneList;
    } catch (error: any) {
      console.log("error->", error);
      return rejectWithValue(error.message);
    }
  }
);
